export default {
  'search-result:results-for': 'Zoekresultaten voor',
  'search-result:results': '{count, number} {count, plural, one {resultaat} other {resultaten}}',
  'search-result:no-results:header': 'Je hebt gezocht naar ‘{term}’',
  'search-result:no-results:sub-header': 'Probeer een andere zoekterm of controleer de spelling.',
  'search-result:no-param:header': 'Oeps!',
  'search-result:error:header': 'Zoeken werkt op dit moment helaas niet',
  'search-result:error:sub-header':
    'Probeer het binnenkort opnieuw. In de tussentijd vind je hier onze populairste producten.',
  'search-result:page-title':
    'Pets Deli Premium diervoeding | Gezond honden- & kattenvoer - Pets Deli',
  'search-result:page-title:dogs':
    'Pets Deli Hondenvoer | BARF, natvoer, droogvoer en meer - Pets Deli',
  'search-result:page-title:cats': 'Premium Kattenvoer | BARF, natvoer en droogvoer - Pets Deli',
  'search-result:bestseller-section-title:dogs': 'Populair bij honden',
  'search-result:bestseller-section-title:cats': 'Populair bij katten',
};
